import Drawable from './Drawable.js';

import { getOSM } from '../OverworldAnimation.js';

export default class WarpZone extends Drawable {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            identifier: this.identifier,
            destinationWarpZone: this.destinationWarpZone,
            destinationDirection: this.destinationDirection,
            destinationZ: this.destinationZ,
            destinationMap: this.destinationMap,
            position: this.position,
            destinationXOffset: this.destinationXOffset,
            destinationYOffset: this.destinationYOffset,
            transitionType: this.transitionType,
            disabled: this.disabled,
        };
    }

    static deserialize(data) {
        return new WarpZone({
            identifier: data.identifier,
            destinationWarpZone: data.destinationWarpZone,
            destinationMap: data.destinationMap,
            position: data.position,
            destinationXOffset: data.destinationXOffset,
            destinationYOffset: data.destinationYOffset,
            transitionType: data.transitionType,
            disabled: data.disabled,
        });
    }

    constructor({
        identifier,
        destinationWarpZone,
        destinationMap,
        position,
        transitionType = 'instant',
        disabled = false,
        parentMap,
        destinationXOffset = 0,
        destinationYOffset = 0,
        destinationDirection,
    }) {
        super();
        this.identifier = identifier;
        this.destinationWarpZone = destinationWarpZone;
        this.destinationMap = destinationMap;
        this.destinationDirection = destinationDirection;
        this.position = position;
        this.destinationXOffset = destinationXOffset;
        this.destinationYOffset = destinationYOffset;
        this.transitionType = transitionType;
        this.disabled = disabled;
        this.visible = true;
        this.width = 16;
        this.height = 16;
        this.parentMap = parentMap;
    }

    entered() {
        const playerPosition = getOSM().player.position;
        return playerPosition.x === this.position.x && playerPosition.y === this.position.y;
    }

    canInteract() {
        return false;
    }

    draw() {
        // c.fillStyle = 'rgba(255, 255, 255, 1)'
        // c.fillRect(this.position.x + this.xModifier, this.position.y + this.yModifier, this.width, this.height)
    }
}
